<template>
  <div class="travel-time-limit" :class="{ disabled }">
    <span class="transport-mode">{{ $t(`transportMode.${transportModeKey}`) }}</span>

    <span v-if="disabled" class="read-only-value">{{ modelValue }}</span>
    <input v-else type="number" min="1" :value="modelValue" @change="$emit('update:modelValue', Number($event.target.value))" />

    <span>{{ $t('travelTimeLimit.minutes') }}</span>
  </div>
</template>

<script>
export default {
  props: {
    transportModeKey: {
      type: String,
      required: true,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    modelValue: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.travel-time-limit {
  display: flex;
  align-items: center;
  color: colors.$nude-concrete-color;
  font-size: 11px;

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    font-style: italic;
  }

  .transport-mode {
    margin-right: auto;
  }

  .read-only-value {
    margin-right: 4px;
  }

  input {
    width: 3ch;
    height: 14px;
    font-size: 11px;
    display: inline-block;
    text-align: center;
    color: currentColor;
    margin: 0 4px;
    border: 1px solid currentColor;
    border-radius: 2px;

    &:active,
    &:focus {
      color: colors.$dark-concrete-color;
    }

    &:invalid {
      color: colors.$red-color;
    }
  }
}
</style>
